(() => {
  const setup = () => {
    document.querySelectorAll('[data-stock-catalog]').forEach(catalog => {
      if (catalog.dataset.stockReady) return;
      const group = catalog.querySelector('[data-stock-group]');
      if (!group) return;
      catalog.dataset.stockReady = 'true';
      const form = group.closest('form'), inputs = [...group.querySelectorAll('input')], grid = catalog.querySelector('[data-stock-grid]'), message = catalog.querySelector('[data-stock-message]'), total = catalog.querySelector('[data-stock-total]'), active = catalog.querySelector('[data-stock-active]');
      const labels = Object.fromEntries(inputs.map(input => [input.value, input.nextElementSibling.textContent]));
      let text;
      try { text = JSON.parse(catalog.dataset.stockText); } catch (_) { return; }
      const native = catalog.querySelector('[data-stock-native]');
      if (native) { native.hidden = true; native.querySelectorAll('input').forEach(input => input.disabled = true); }
      group.hidden = false;
      const query = new URL(location.href);
      const sort = [...form.elements].find(element => element.name === 'sort_by');
      const ratingGroup = form.querySelector('[data-rating-group]');
      const ratingMin = ratingGroup?.querySelector('[name="cz_min_rating"]'), ratingMax = ratingGroup?.querySelector('[name="cz_max_rating"]'), ratingToggle = ratingGroup?.querySelector('[data-rating-enabled]');
      const ratingBounds = () => {
        const params = new URL(location.href).searchParams;
        const valid = key => params.has(key) && params.get(key) !== '' && Number.isFinite(Number(params.get(key)));
        const enabled = valid('cz_min_rating') || valid('cz_max_rating');
        const low = valid('cz_min_rating') ? Math.max(1, Math.min(5, Number(params.get('cz_min_rating')))) : 1;
        const high = valid('cz_max_rating') ? Math.max(1, Math.min(5, Number(params.get('cz_max_rating')))) : 5;
        return {enabled, low: Math.min(low, high), high: Math.max(low, high)};
      };
      const syncRating = () => {
        if (!ratingMin || !ratingMax) return;
        ratingMin.disabled = ratingMax.disabled = false;
        ratingGroup.querySelector('[data-rating-low]').textContent = Number(ratingMin.value).toLocaleString(document.documentElement.lang);
        ratingGroup.querySelector('[data-rating-high]').textContent = Number(ratingMax.value).toLocaleString(document.documentElement.lang);
      };
      const restoreRating = () => {
        if (!ratingGroup) return;
        const bounds = ratingBounds(); ratingToggle.checked = bounds.enabled;
        ratingMin.value = bounds.low; ratingMax.value = bounds.high; syncRating();
      };
      restoreRating();
      ratingToggle?.addEventListener('change', syncRating);
      [ratingMin, ratingMax].filter(Boolean).forEach(input => input.addEventListener('input', () => {
        ratingToggle.checked = true;
        if (Number(ratingMin.value) > Number(ratingMax.value)) {
          if (input === ratingMin) ratingMax.value = ratingMin.value; else ratingMin.value = ratingMax.value;
        }
        syncRating();
      }));
      const discountOrder = () => new URL(location.href).searchParams.get('cz_discount') === 'desc';
      const ratingOrder = () => ['asc', 'desc'].includes(new URL(location.href).searchParams.get('cz_rating')) ? new URL(location.href).searchParams.get('cz_rating') : '';
      if (sort && discountOrder()) sort.value = 'cz-discount-desc';
      if (sort && ratingOrder()) sort.value = 'cz-rating-' + ratingOrder();

      catalog.querySelectorAll('[data-dual-range]').forEach(track => {
        const [low, high] = track.querySelectorAll('input[type="range"]');
        const price = track.closest('[data-price-dual]');
        const fields = price ? [...price.querySelectorAll('input[type="number"]')] : [];
        const paint = () => {
          const span = Number(low.max) - Number(low.min) || 1;
          track.style.setProperty('--low', ((Number(low.value) - Number(low.min)) / span * 100) + '%');
          track.style.setProperty('--high', ((Number(high.value) - Number(low.min)) / span * 100) + '%');
          low.style.zIndex = Number(low.value) >= Number(low.max) ? '4' : '2';
        };
        [low, high].forEach(input => input.addEventListener('input', () => {
          if (Number(low.value) > Number(high.value)) {
            if (input === low) high.value = low.value; else low.value = high.value;
          }
          if (fields.length === 2) {
            fields[0].value = Number(low.value).toFixed(2); fields[1].value = Number(high.value).toFixed(2);
          }
          paint();
        }));
        fields.forEach((field,index) => field.addEventListener('input', () => {
          if (field.value !== '' && !Number.isFinite(field.valueAsNumber)) return;
          const input = index === 0 ? low : high;
          input.value = field.value === '' ? (index === 0 ? input.min : input.max) : field.value;
          if (Number(low.value) > Number(high.value)) {
            if (index === 0) { high.value = low.value; fields[1].value = high.value; }
            else { low.value = high.value; fields[0].value = low.value; }
          }
          paint();
        }));
        paint();
        addEventListener('popstate', paint);
      });
      const selected = new Set(query.searchParams.getAll('cz_stock').filter(value => labels[value]));
      if (!selected.size && query.searchParams.has('filter.v.availability')) {
        if (query.searchParams.getAll('filter.v.availability').includes('1')) { selected.add('in_stock'); selected.add('preorder'); }
        if (query.searchParams.getAll('filter.v.availability').includes('0')) selected.add('sold_out');
      }
      inputs.forEach(input => input.checked = selected.has(input.value));
      const endpoint = new URL(location.href);
      ['cz_discount','cz_max_rating','cz_min_rating','cz_rating','cz_stock','cz_page','page','view','filter.v.availability','section_id'].forEach(key => endpoint.searchParams.delete(key));
      endpoint.searchParams.set('view', 'cz-stock');
      const pageSize = Math.max(1, Number(catalog.dataset.stockPageSize) || 32);
      let records, loading, revision = 0;
      const getPage = async number => {
        const url = new URL(endpoint); url.searchParams.set('page', number);
        const response = await fetch(url, {headers: {Accept: 'text/html'}});
        if (!response.ok) throw new Error('catalog');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const scope = doc.querySelector('[data-stock-page]');
        if (!scope) throw new Error('catalog');
        return {pages: Number(scope.dataset.stockPages) || 1, items: [...scope.querySelectorAll('[data-stock-item]')].map(item => ({id: item.dataset.stockItem, state: item.dataset.stockState, discount: Number(item.dataset.discount) || 0, rating: Number(item.dataset.rating) || 0, reviews: Number(item.dataset.reviewCount) || 0, html: item.innerHTML}))};
      };
      const load = () => {
        if (records) return Promise.resolve(records);
        if (loading) return loading;
        loading = (async () => {
          const first = await getPage(1), pages = [first];
          for (let start = 2; start <= first.pages; start += 3) {
            const batch = [];
            for (let number = start; number < start + 3 && number <= first.pages; number++) batch.push(getPage(number));
            pages.push(...await Promise.all(batch));
          }
          const seen = new Set();
          records = pages.flatMap(page => page.items).filter(item => { if (seen.has(item.id)) return false; seen.add(item.id); return true; });
          const counts = {in_stock: 0, preorder: 0, sold_out: 0};
          records.forEach(item => counts[item.state]++);
          group.querySelectorAll('[data-stock-count]').forEach(node => node.textContent = counts[node.dataset.stockCount]);
          return records;
        })().catch(error => { loading = null; throw error; });
        return loading;
      };
      const pagination = document.createElement('nav'); pagination.className = 'pagination'; pagination.setAttribute('aria-label', text.pagination); pagination.hidden = true; grid.after(pagination);
      const render = async (number = 1) => {
        const version = ++revision;
        const states = new Set(inputs.filter(input => input.checked).map(input => input.value));
        message.hidden = false; message.textContent = text.loading; grid.setAttribute('aria-busy', 'true'); grid.hidden = true;
        try {
          const all = await load(); if (version !== revision) return;
          const items = all.filter(item => (!states.size || states.has(item.state)) && (!ratingBounds().enabled || (item.reviews > 0 && item.rating >= ratingBounds().low && item.rating <= ratingBounds().high)));
          const order = ratingOrder();
          if (order) items.sort((a, b) => {
            const aRated = a.reviews > 0 && a.rating > 0, bRated = b.reviews > 0 && b.rating > 0;
            if (aRated !== bRated) return aRated ? -1 : 1;
            if (!aRated) return 0;
            return (order === 'asc' ? a.rating - b.rating : b.rating - a.rating) || b.reviews - a.reviews;
          });
          if (discountOrder()) items.sort((a,b) => b.discount - a.discount);
          const pages = Math.max(1, Math.ceil(items.length / pageSize));
          const page = Math.max(1, Math.min(number, pages));
          grid.innerHTML = items.slice((page - 1) * pageSize, page * pageSize).map(item => item.html).join('');
          total.textContent = text.products.replace('{count}', items.length);
          message.hidden = items.length > 0; message.textContent = text.empty;
          catalog.querySelectorAll('[data-stock-pagination]').forEach(node => node.hidden = true);
          pagination.replaceChildren(); pagination.hidden = pages < 2;
          const link = (target, label) => {
            const a = document.createElement('a'), url = new URL(location.href); url.searchParams.set('cz_page', target); url.searchParams.delete('page'); a.href = url; a.textContent = label;
            a.addEventListener('click', event => { if (event.button || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return; event.preventDefault(); history.pushState(null, '', url); render(target); catalog.querySelector('.collection-toolbar').scrollIntoView({block: 'start'}); });
            pagination.append(a);
          };
          if (page > 1) link(page - 1, text.previous);
          const position = document.createElement('span'); position.textContent = `${page} / ${pages}`; position.setAttribute('aria-current', 'page'); pagination.append(position);
          if (page < pages) link(page + 1, text.next);
          active.replaceChildren();
          states.forEach(state => { const a = document.createElement('a'), url = new URL(location.href); url.searchParams.delete('cz_stock'); url.searchParams.delete('cz_page'); url.searchParams.delete('page'); url.searchParams.delete('filter.v.availability'); [...states].filter(value => value !== state).forEach(value => url.searchParams.append('cz_stock', value)); a.href = url; a.textContent = `${labels[state]} ×`; active.append(a); });
          catalog.querySelectorAll('.cz-filter-group:not([data-stock-group]) small').forEach(node => node.hidden = true);
          grid.hidden = false;
        } catch (_) {
          if (version !== revision) return;
          message.replaceChildren(document.createTextNode(text.error + ' '));
          const retry = document.createElement('button'); retry.type = 'button'; retry.className = 'btn btn-ghost'; retry.textContent = text.retry; retry.addEventListener('click', () => render(number)); message.append(retry);
        } finally { if (version === revision) grid.removeAttribute('aria-busy'); }
      };
      form.addEventListener('submit', () => {
        native?.querySelectorAll('input').forEach(input => input.disabled = true);
        if (ratingMin && !ratingToggle.checked) {
          ratingMin.disabled = ratingMax.disabled = true;
          setTimeout(() => { ratingMin.disabled = ratingMax.disabled = false; }, 0);
        }
        form.querySelectorAll('input[name="cz_rating"],input[name="cz_discount"]').forEach(input => input.remove());
        if (sort && sort.value === 'cz-discount-desc') { const input = document.createElement('input'); input.type='hidden'; input.name='cz_discount'; input.value='desc'; form.append(input); sort.disabled=true; setTimeout(() => { sort.disabled=false; },0); }
        if (sort && /^cz-rating-(asc|desc)$/.test(sort.value)) {
          const input = document.createElement('input'); input.type = 'hidden'; input.name = 'cz_rating'; input.value = sort.value.slice(10); form.append(input);
          sort.disabled = true;
          setTimeout(() => { sort.disabled = false; }, 0);
        }
      });
      group.addEventListener('focusin', () => load().catch(() => {}), {once: true});
      group.addEventListener('pointerenter', () => load().catch(() => {}), {once: true});
      if (selected.size || discountOrder() || ratingOrder() || ratingBounds().enabled) render(Number(query.searchParams.get('cz_page')) || 1);
      addEventListener('popstate', () => { const url = new URL(location.href), states = url.searchParams.getAll('cz_stock'); restoreRating(); if (sort) sort.value = discountOrder() ? 'cz-discount-desc' : ratingOrder() ? 'cz-rating-' + ratingOrder() : (url.searchParams.get('sort_by') || sort.options[0].value); inputs.forEach(input => input.checked = states.includes(input.value)); render(Number(url.searchParams.get('cz_page')) || 1); });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  document.addEventListener('shopify:section:load', setup);
})();

